import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck, ShieldCheck, Clock } from 'lucide-react';
const advantages = [{
  icon: <FileCheck size={28} strokeWidth={1.5} data-id="element-30" />,
  title: 'Офіційне оформлення',
  description: 'Тільки законні способи реєстрації. Ви отримуєте прописку, яка діє без обмежень і не створить проблем у майбутньому.'
}, {
  icon: <ShieldCheck size={28} strokeWidth={1.5} data-id="element-31" />,
  title: 'Без відмов і тяганини',
  description: 'Знаємо всі вимоги ЦНАПів Києва. Готуємо пакет документів так, щоб заявку прийняли з першого разу.'
}, {
  icon: <Clock size={28} strokeWidth={1.5} data-id="element-32" />,
  title: 'Швидкий результат',
  description: 'Оформлюємо прописку у стислі терміни. Більшість клієнтів отримують реєстрацію за 1–3 робочі дні.'
}];
export function Advantages() {
  return <section className="py-24 bg-background" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6" data-id="element-34">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-36">
            Чому обирають нас
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-37">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-surface p-8 rounded-3xl border border-border hover:border-primary/50 transition-colors duration-300" data-id="element-38">
              <div className="w-14 h-14 bg-background rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-39">
                {adv.icon}
              </div>
              <h3 className="text-xl font-medium mb-3" data-id="element-40">{adv.title}</h3>
              <p className="text-secondary leading-relaxed text-sm" data-id="element-41">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}